import { convertingStatusTable, convertingToPortuguese, StatusKeys } from './translation';
import { Attendance } from '../hooks/useUserData';
import { FilterKeys } from './types';

export function filterUserData(userData: Attendance[], filterValues: FilterKeys) {
  let filteredAttendances = userData;

  if (filterValues.date && filterValues.date.length > 0 ) {
    const regex = /(\d{4})-(\d{2})-(\d{2})/;
    const [year, month, day] = filterValues.date.match(regex) as string[];
    filteredAttendances = filteredAttendances.filter((attendance) => {
      const [yearAttendance, monthAttendance, dayAttendance] = attendance.created_at.match(regex) as string[];
      return (
          year === yearAttendance &&
          month === monthAttendance &&
          day === dayAttendance
      ) 
    });
  }

  if (filterValues.number) {
    filteredAttendances = filteredAttendances.filter((attendance) => attendance.number === filterValues.number?.trim());
  }

  if (filterValues.status) {
    filteredAttendances = filteredAttendances.filter(
      (attendance) => convertingStatusTable[attendance.status as StatusKeys] === filterValues.status?.trim(),
    );
  }

  if (filterValues.subject) {
    filteredAttendances = filteredAttendances.filter(
      (attendance) => attendance.subject === filterValues.subject?.trim(),
    );
  }
  return filteredAttendances;
}
